import * as React from 'react';

import { Text } from '@shared/components/bootstrap';

const DATE = new Date();

export const Copyright: React.FC = () => (
  <Text style="muted">© {DATE.getFullYear()} Clutter Inc. - All Rights Reserved</Text>
);
